import script from "./TimeGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeGroup.vue?vue&type=script&setup=true&lang=js"

import "./TimeGroup.vue?vue&type=style&index=0&id=8abe9e1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8abe9e1e"]])

export default __exports__